<template>
  <div v-if="pageshow" class="block">
    <el-pagination
      background
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'
export default {
  name: 'PaginationRight',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      require: true,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    scroll: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: function() {
        // return [10, 20, 30, 50]
        return [10]
      }
    }

  },
  data() {
    return {
      pageshow: true
    }
  },
  methods: {
    // val 是切换之后的每页显示多少条npm
    handleSizeChange(val) {
      this.$emit('size-change', val)
      this.scrollTop()
    },
    // 当前页码改变后触发，val 是当前 点击或输入 的页码
    handleCurrentChange(val) {
      this.$emit('current-change', val)
      this.scrollTop()
    },
    // 滚动至页面顶部
    scrollTop() {
      if (this.scroll) {
        scrollTo(0, 800)
      }
    },
    select(val) {
      this.currentPage = val
      this.pageshow = false
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true// 让分页隐藏
      })
    }

  }
}
</script>

<style scoped lang="less">
  .block {
    display: flex;
    justify-content: right;
    padding: 20px;
  }
</style>
